var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategorySoups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_8287)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_465_8287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.4727 136.131C56.8762 136.131 39.8097 134.298 26.4418 131.241C28.365 136.306 31.9782 140.137 36.4335 141.363C46.4888 144.13 60.2691 145.836 75.4727 145.836C90.6762 145.836 104.456 144.13 114.512 141.363C118.967 140.137 122.58 136.306 124.504 131.241C111.136 134.298 94.0691 136.131 75.4727 136.131Z",
    fill: "url(#paint0_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.473 121.768C150.473 147.48 0.4729 147.48 0.4729 121.768C0.4729 96.0555 150.473 96.0552 150.473 121.768Z",
    fill: "url(#paint1_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.178 119.882C140.178 138.214 10.7667 138.214 10.7667 119.882C10.7667 101.55 140.178 101.551 140.178 119.882Z",
    fill: "url(#paint2_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.473 121.768C150.473 102.831 69.1164 97.8417 26.2358 106.798C28.6838 110.624 31.5117 114.224 34.6979 117.533L62.5973 145.416C66.7306 145.69 71.0403 145.836 75.4726 145.836C90.6761 145.836 104.456 144.13 114.512 141.363C116.83 140.725 118.917 139.377 120.659 137.522C138.191 134.375 150.473 129.124 150.473 121.768Z",
    fill: "url(#paint3_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4727 122.638C62.5107 122.638 50.6154 120.812 41.2977 117.767C42.6383 122.812 45.1568 126.628 48.2621 127.848C55.2707 130.605 64.8757 132.304 75.4727 132.304C86.0698 132.304 95.6748 130.605 102.683 127.848C105.789 126.627 108.307 122.812 109.648 117.767C100.33 120.812 88.4348 122.638 75.4727 122.638Z",
    fill: "url(#paint4_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.267 87.6249C125.267 89.821 127.047 91.6013 129.243 91.6013H141.001C145.716 91.6013 149.538 87.781 149.538 83.0634C149.538 80.7072 148.581 78.5722 147.037 77.0275C145.492 75.4802 143.359 74.5258 141.001 74.5258H135.461C135.399 75.3943 135.318 76.2605 135.222 77.1211C134.975 79.3187 134.624 81.4978 134.171 83.6487H129.243C127.047 83.6487 125.267 85.4287 125.267 87.6249Z",
    fill: "url(#paint5_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.267 87.6249C125.267 89.821 127.047 91.6013 129.243 91.6013H141.001C145.716 91.6013 149.538 87.781 149.538 83.0634C149.538 80.7072 148.581 78.5722 147.037 77.0275C145.492 75.4802 143.359 74.5258 141.001 74.5258H135.461C135.399 75.3943 135.318 76.2605 135.222 77.1211C134.975 79.3187 134.624 81.4978 134.171 83.6487H129.243C127.047 83.6487 125.267 85.4287 125.267 87.6249Z",
    fill: "url(#paint6_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.172 83.6487H138.27C140.244 83.6487 141.843 82.0493 141.843 80.0755C141.843 79.2613 141.513 78.5228 140.98 77.9872C140.444 77.4516 139.708 77.1213 138.892 77.1213H135.222C134.975 79.3184 134.624 81.4978 134.172 83.6487Z",
    fill: "url(#paint7_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8516 123.783C65.3589 128.14 85.5869 128.14 105.094 123.783C109.343 122.835 113.228 120.669 116.248 117.533C128.632 104.672 135.651 87.444 135.651 69.4049V67.7214C135.651 41.0287 15.2948 41.0287 15.2948 67.7214V69.4049C15.2948 87.444 22.3139 104.672 34.698 117.533C37.7174 120.669 41.6027 122.835 45.8516 123.783Z",
    fill: "url(#paint8_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.651 67.7214C135.651 94.414 15.2945 94.414 15.2945 67.7214C15.2945 41.0287 135.651 41.0287 135.651 67.7214Z",
    fill: "url(#paint9_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.515 66.2787C129.515 87.4234 21.431 87.4234 21.431 66.2787C21.431 45.134 129.515 45.134 129.515 66.2787Z",
    fill: "url(#paint10_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4561 71.9846C40.0149 85.5208 110.93 85.5208 126.489 71.9846C110.93 58.4485 40.0152 58.4485 24.4561 71.9846Z",
    fill: "url(#paint11_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.286 78.5082C111.506 77.99 111.621 77.4497 111.621 76.8865C111.621 62.7429 39.3242 62.7429 39.3242 76.8865C39.3242 77.4494 39.4398 77.99 39.6598 78.5082C59.5939 83.3456 91.3516 83.3456 111.286 78.5082Z",
    fill: "url(#paint12_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3282 79.6988C48.088 66.4888 102.858 66.4888 105.617 79.6988C87.6894 82.9479 63.2559 82.9479 45.3282 79.6988Z",
    fill: "url(#paint13_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6414 75.1746C54.6414 76.8338 46.3967 76.8338 46.3967 75.1746C46.3967 73.5155 48.2423 72.1705 50.5191 72.1705C52.7958 72.1705 54.6414 73.5155 54.6414 75.1746Z",
    fill: "url(#paint14_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.872 70.5543C114.872 72.2134 106.627 72.2134 106.627 70.5543C106.627 68.8952 108.473 67.5502 110.75 67.5502C113.026 67.5502 114.872 68.8952 114.872 70.5543Z",
    fill: "url(#paint15_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7643 81.9487C69.3422 82.0587 71.9463 82.1196 74.5546 82.1311C74.0364 80.9037 72.4687 80.0114 70.6143 80.0114C68.8537 80.0114 67.3552 80.8169 66.7643 81.9487Z",
    fill: "url(#paint16_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.067 75.8699C105.589 75.6364 105.012 75.8349 104.779 76.3131C104.545 76.7914 104.744 77.3684 105.222 77.6017C105.7 77.8352 106.277 77.6366 106.511 77.1584C106.744 76.6805 106.546 76.1034 106.067 75.8699Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.644 74.2875C112.267 74.1031 111.811 74.2599 111.627 74.6375C111.443 75.0152 111.599 75.4705 111.977 75.6549C112.355 75.839 112.81 75.6825 112.994 75.3049C113.178 74.9272 113.022 74.4716 112.644 74.2875Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.41 70.8945C111.182 70.7834 110.907 70.8778 110.797 71.1054C110.685 71.3331 110.78 71.6078 111.007 71.7187C111.235 71.8298 111.51 71.7351 111.621 71.5078C111.732 71.2801 111.637 71.0054 111.41 70.8945Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1999 66.1414C60.6679 66.1443 60.2388 66.5781 60.2417 67.1105C60.2447 67.6425 60.6785 68.0717 61.2105 68.0687C61.7426 68.0658 62.1717 67.632 62.1688 67.0999C62.1661 66.5675 61.7323 66.1384 61.1999 66.1414Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6646 69.8134C52.2446 69.8157 51.9057 70.1581 51.9081 70.5784C51.9104 70.9984 52.2528 71.3372 52.6731 71.3348C53.0934 71.3325 53.4319 70.9901 53.4296 70.5698C53.4272 70.1498 53.0849 69.811 52.6646 69.8134Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7374 75.8187C65.4842 75.8202 65.2801 76.0267 65.2813 76.2799C65.2824 76.5331 65.4892 76.7376 65.7424 76.7361C65.9957 76.7346 66.1998 76.5281 66.1986 76.2749C66.1971 76.0214 65.9907 75.8173 65.7374 75.8187Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.73 69.0331C101.35 69.1334 101.123 69.5228 101.223 69.9031C101.323 70.2834 101.713 70.5105 102.093 70.4102C102.473 70.3099 102.7 69.9205 102.6 69.5402C102.5 69.1599 102.11 68.9328 101.73 69.0331Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.494 74.6184C100.193 74.6975 100.014 75.0049 100.093 75.3052C100.173 75.6055 100.48 75.7846 100.78 75.7055C101.08 75.6263 101.26 75.3187 101.18 75.0187C101.101 74.7187 100.794 74.5393 100.494 74.6184Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.561 73.9669C109.38 74.0146 109.272 74.2002 109.32 74.3811C109.367 74.5619 109.553 74.6702 109.734 74.6225C109.915 74.5749 110.023 74.3893 109.975 74.2084C109.928 74.0272 109.742 73.9193 109.561 73.9669Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0593 75.4114C48.5811 75.1779 48.004 75.3764 47.7708 75.8546C47.5372 76.3329 47.7358 76.9099 48.214 77.1432C48.6922 77.3767 49.2693 77.1782 49.5025 76.6999C49.7361 76.2217 49.5375 75.6449 49.0593 75.4114Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0368 71.3234C56.6592 71.139 56.2039 71.2958 56.0195 71.6734C55.835 72.0511 55.9918 72.5063 56.3695 72.6908C56.7471 72.8752 57.2024 72.7184 57.3868 72.3408C57.5712 71.9631 57.4145 71.5078 57.0368 71.3234Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2605 68.1537C50.0328 68.0425 49.7581 68.1369 49.6472 68.3646C49.536 68.5922 49.6305 68.8669 49.8581 68.9778C50.0857 69.089 50.3605 68.9946 50.4713 68.7669C50.5825 68.5393 50.4881 68.2649 50.2605 68.1537Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8008 71.1846C39.7978 70.6525 39.364 70.2234 38.8317 70.2263C38.2996 70.2293 37.8705 70.6631 37.8734 71.1952C37.8764 71.7272 38.3102 72.1563 38.8425 72.1534C39.3749 72.1507 39.8037 71.7169 39.8008 71.1846Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7488 72.6704C39.3288 72.6728 38.99 73.0151 38.9923 73.4354C38.9947 73.8554 39.337 74.1943 39.7573 74.1919C40.1773 74.1895 40.5161 73.8472 40.5138 73.4269C40.5114 73.0069 40.1691 72.6681 39.7488 72.6704Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9635 73.3381C41.7103 73.3396 41.5062 73.5461 41.5073 73.7993C41.5088 74.0526 41.7153 74.2567 41.9685 74.2555C42.2217 74.2543 42.4259 74.0476 42.4247 73.7943C42.4232 73.5411 42.2167 73.3367 41.9635 73.3381Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5335 66.0855C45.1532 66.1858 44.9261 66.5752 45.0264 66.9555C45.1267 67.3358 45.5161 67.5628 45.8964 67.4625C46.2767 67.3622 46.5037 66.9728 46.4035 66.5925C46.3032 66.2122 45.9137 65.9852 45.5335 66.0855Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3315 71.1823C42.0312 71.2614 41.8521 71.5687 41.9312 71.869C42.0103 72.1693 42.3177 72.3484 42.6179 72.2693C42.9182 72.1902 43.0973 71.8829 43.0182 71.5826C42.9394 71.2826 42.6318 71.1031 42.3315 71.1823Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8648 71.0931C44.6839 71.1408 44.5757 71.3261 44.6233 71.5073C44.6709 71.6881 44.8565 71.7964 45.0374 71.7487C45.2183 71.7011 45.3265 71.5155 45.2789 71.3346C45.2312 71.1534 45.0457 71.0452 44.8648 71.0931Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8631 70.5543C69.8631 72.2134 61.6184 72.2134 61.6184 70.5543C61.6184 68.8952 63.464 67.5502 65.7408 67.5502C68.0175 67.5502 69.8631 68.8952 69.8631 70.5543Z",
    fill: "url(#paint17_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7495 67.0357C71.166 68.3389 71.9104 70.1907 71.4122 71.1715C70.9139 72.1524 69.3616 71.8907 67.9451 70.5874C66.5286 69.2842 63.698 65.513 64.1963 64.5321C64.6948 63.5513 68.333 65.7321 69.7495 67.0357Z",
    fill: "url(#paint18_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9164 66.8125C72.2293 69.206 71.5705 71.2784 70.4446 71.441C69.3187 71.604 68.1522 69.7954 67.8393 67.4019C67.5264 65.0084 67.7243 59.4113 68.8499 59.2484C69.9758 59.086 71.6031 64.419 71.9164 66.8125Z",
    fill: "url(#paint19_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0792 63.9994C78.7513 63.9832 78.4233 64.0197 78.1054 64.1017C76.0992 64.6197 68.3251 66.9117 68.071 71.3835C67.9083 74.2447 72.6351 75.1294 76.8542 75.3517C80.7069 75.5549 84.0313 73.5011 84.2572 70.7849C84.5101 67.7411 83.7657 64.2326 79.0792 63.9994Z",
    fill: "url(#paint20_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1177 64.0058C78.7779 63.9717 78.4365 64.0161 78.1059 64.1014C76.1021 64.6184 68.3241 66.9105 68.07 71.3834C67.9074 74.2446 72.6341 75.1293 76.8532 75.3517C80.6547 75.5523 83.6677 64.4611 79.1177 64.0058Z",
    fill: "url(#paint21_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3599 76.6988C99.3599 78.3579 91.1152 78.3579 91.1152 76.6988C91.1152 75.0397 92.9608 73.6947 95.2376 73.6947C97.5144 73.6947 99.3599 75.0397 99.3599 76.6988Z",
    fill: "url(#paint22_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3888 103.737C27.2226 108.715 30.6753 113.355 34.6982 117.533C37.7179 120.669 41.6029 122.835 45.8517 123.783C65.3591 128.14 85.587 128.14 105.094 123.783C109.343 122.835 113.228 120.669 116.248 117.533C120.271 113.355 123.723 108.714 126.557 103.737H24.3888Z",
    fill: "url(#paint23_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3728 126.746C61.8993 126.446 57.4346 125.922 52.9993 125.181C50.6081 124.778 48.2258 124.313 45.8522 123.784C41.6022 122.834 37.7169 120.669 34.6993 117.534C27.6287 110.193 22.3081 101.428 19.0434 91.9016C18.1316 89.2457 17.3816 86.5281 16.7963 83.7663C16.7963 83.7575 16.7934 83.7457 16.7905 83.734C16.7875 83.7046 16.7816 83.6781 16.7758 83.6487H21.7022C23.0258 83.6487 24.1934 84.2957 24.9169 85.2899L66.3728 126.746Z",
    fill: "url(#paint24_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6791 87.6249C25.6791 89.821 23.8988 91.6013 21.7026 91.6013H9.94523C5.23023 91.6013 1.40729 87.781 1.40729 83.0634C1.40729 80.7072 2.36435 78.5722 3.90905 77.0275C5.45376 75.4802 7.58641 74.5258 9.94523 74.5258H15.4846C15.547 75.3943 15.6276 76.2605 15.7238 77.1211C15.9708 79.3187 16.322 81.4978 16.7743 83.6487H21.7026C23.8988 83.6487 25.6791 85.4287 25.6791 87.6249Z",
    fill: "url(#paint25_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7744 83.6487H12.6758C10.702 83.6487 9.1026 82.0493 9.1026 80.0755C9.1026 79.2613 9.43289 78.5228 9.96613 77.9872C10.5017 77.4516 11.2379 77.1213 12.0544 77.1213H15.7238C15.9708 79.3184 16.322 81.4978 16.7744 83.6487Z",
    fill: "url(#paint26_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.524 29.6011C96.1704 28.6631 97.1419 27.7858 97.9775 28.2843C100.929 30.0458 105.262 33.6705 105.262 39.7702C105.262 49.0205 94.6443 49.8925 94.6443 56.7446C94.6443 60.2611 95.0881 62.6893 95.5201 64.2205C95.7701 65.1061 94.9066 65.8864 94.1113 65.4914C91.4657 64.1781 87.3966 60.9734 87.3966 53.6849C87.3966 42.8858 97.9266 43.0464 97.9266 37.142C97.9266 34.0584 97.2093 31.4193 96.524 29.6011Z",
    fill: "url(#paint27_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8917 4.48161C79.6612 4.06867 80.2782 3.6922 80.6917 3.9922C83.4964 6.02749 88.2397 10.3304 88.2397 16.1519C88.2397 24.4169 79.2626 26.7566 78.0664 33.2016C77.0988 38.4151 79.3164 43.4898 80.3332 45.461C80.5097 45.8031 80.1035 46.1499 79.6829 46.0178C76.5897 45.0457 68.2682 41.4434 69.5109 31.0651C70.7147 21.0113 79.7197 21.4704 81.3176 14.9654C82.4656 10.2948 81.0512 6.55779 79.8917 4.48161Z",
    fill: "url(#paint28_linear_465_8287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9854 31.7984C50.6701 31.0246 51.3307 30.3005 51.9736 30.712C54.2448 32.1655 57.6407 35.1564 58.0039 40.1899C58.5548 47.8228 50.8142 48.5425 51.2224 54.1967C51.4318 57.0981 51.9021 59.102 52.3104 60.3655C52.5465 61.0961 51.9595 61.7402 51.3521 61.4143C49.3324 60.3308 46.1554 57.6864 45.7212 51.672C45.078 42.7608 52.8154 42.8934 52.4636 38.0211C52.2801 35.4767 51.5965 33.2987 50.9854 31.7984Z",
    fill: "url(#paint29_linear_465_8287)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_8287",
    x1: 75.7521,
    y1: 135.851,
    x2: 76.3403,
    y2: 145.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_465_8287",
    x1: 70.5455,
    y1: 103.171,
    x2: 82.1005,
    y2: 146.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_465_8287",
    x1: 78.6988,
    y1: 145.691,
    x2: 73.1106,
    y2: 100.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_465_8287",
    x1: 102.144,
    y1: 147.129,
    x2: 37.2426,
    y2: -10.5178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_465_8287",
    x1: 75.7771,
    y1: 122.791,
    x2: 76.328,
    y2: 131.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_465_8287",
    x1: 137.618,
    y1: 81.8522,
    x2: 137.034,
    y2: 91.4934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_465_8287",
    x1: 139.986,
    y1: 83.4155,
    x2: 123.516,
    y2: 82.2019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_465_8287",
    x1: 138.627,
    y1: 78.3363,
    x2: 136.286,
    y2: 89.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_465_8287",
    x1: 66.2707,
    y1: 53.3193,
    x2: 98.7545,
    y2: 129.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_465_8287",
    x1: 86.7001,
    y1: 109.569,
    x2: 76.3163,
    y2: 70.8661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_465_8287",
    x1: 75.4731,
    y1: 77.831,
    x2: 75.4731,
    y2: -0.57189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_465_8287",
    x1: 75.4725,
    y1: 62.1185,
    x2: 75.4725,
    y2: 87.8661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_465_8287",
    x1: 76.4245,
    y1: 74.3609,
    x2: 111.325,
    y2: -18.1836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_465_8287",
    x1: 75.2088,
    y1: 76.3246,
    x2: 70.1812,
    y2: 12.0028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_465_8287",
    x1: 50.1673,
    y1: 73.9785,
    x2: 51.8576,
    y2: 79.0496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_465_8287",
    x1: 110.398,
    y1: 69.3581,
    x2: 112.088,
    y2: 74.4293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_465_8287",
    x1: 70.3861,
    y1: 81.2193,
    x2: 71.6011,
    y2: 84.8652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_465_8287",
    x1: 64.2108,
    y1: 67.4011,
    x2: 67.1319,
    y2: 73.0096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_465_8287",
    x1: 68.0146,
    y1: 67.1712,
    x2: 66.8271,
    y2: 69.5718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_465_8287",
    x1: 70.4765,
    y1: 65.2135,
    x2: 67.2738,
    y2: 67.7404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_465_8287",
    x1: 75.506,
    y1: 68.047,
    x2: 77.766,
    y2: 75.0323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_465_8287",
    x1: 73.6365,
    y1: 65.809,
    x2: 77.2774,
    y2: 77.1217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_465_8287",
    x1: 93.7076,
    y1: 73.5453,
    x2: 96.6288,
    y2: 79.1541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_465_8287",
    x1: 75.4729,
    y1: 112.828,
    x2: 75.4729,
    y2: 147.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_465_8287",
    x1: 37.1899,
    y1: 105.31,
    x2: -28.2513,
    y2: 75.8981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_465_8287",
    x1: 13.3273,
    y1: 81.8522,
    x2: 13.9117,
    y2: 91.4934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_465_8287",
    x1: 12.3194,
    y1: 78.3363,
    x2: 14.66,
    y2: 89.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_465_8287",
    x1: 90.6566,
    y1: 44.3211,
    x2: 116.359,
    y2: 56.5531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DFBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_465_8287",
    x1: 71.7473,
    y1: 22.9975,
    x2: 89.9564,
    y2: 27.2819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1575,
    stopColor: "#E97869",
    stopOpacity: 0.158
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3778,
    stopColor: "#EC8B78",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#F0A991",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9188,
    stopColor: "#F6D2B3",
    stopOpacity: 0.919
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DFBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_465_8287",
    x1: 45.9327,
    y1: 43.8243,
    x2: 59.8536,
    y2: 49.2493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DFBE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_8287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.432373)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_465_8287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.4729 -0.139893)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategorySoups);
export default __webpack_public_path__ + "static/media/icon-category-soups.c6171ce7.svg";
export { ForwardRef as ReactComponent };